// const Icon = require('./connected.png');
// const IconGray = require('./unconnected.png');
const Full = require('./full.png');
export { 
// Icon,
// IconGray,
Full };
//# sourceMappingURL=index.js.map